import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { STATIC_STRINGS } from "@asez/shared";
import PageWrapper from "../../../components/PageWrapper";

const RenderError = ({
  onRetry,
  error,
}: {
  onRetry?: () => void;
  error?: any;
}) => {
  return (
    <PageWrapper>
      <div className="card h-full w-full flex flex-col justify-center items-center">
        <ErrorOutlineIcon color="error" fontSize="large" />
        <h2 className="text-lg font-semibold text-red-600 mt-2">
          {STATIC_STRINGS.ERROR_MESSAGE}
        </h2>
        <p className="text-gray-600 mt-1">
          {STATIC_STRINGS.CREATE_ASSESSMENT_API_ERROR}
        </p>
        <button
          onClick={onRetry ?? (() => window.location.reload())}
          className="btn btn-outline mt-2"
        >
          {STATIC_STRINGS.RETRY}
        </button>
      </div>
    </PageWrapper>
  );
};

export default RenderError;
